export class SubjectResponse {
    subjects: Subject[] = [];
    more_rows = false;

    isSingle(): boolean {
        return this.subjects.length <= 1 && !this.more_rows
    }
}

export class Subject {
    subject_id!: string;
    fiscal_code!: string;
    vat_number!: null;
    fg_vat_number!: null;
    full_name!: string;
    name!: string;
    last_name!: string;
    residence_id!: string;
    residence_council!: string;
    residence_province!: string;
    person_type!: string;
    req_ps_approval = false;

    toString(): string {
        return `${this.full_name} - ${this.fiscal_code}`;
    }
}
